import auth from './auth';
import debounce from './debounce';
import getPastTime from './getPastTime';
import getQueryString from './getQueryString';
import removeProps from './removeProps';
import setDownloadOptions from './setDownloadOptions';
import throttle from './throttle';
import { getCookie, setCookie, removeCookie } from './cookie';

const globalVariables = {
  subNavHeight: 0,
  timer: null,
  delta: 50,
	ua: process.browser ?window.navigator.userAgent.toLowerCase():'',
  taggingObj: {}
};

globalVariables.isMobile = globalVariables.ua.match(/iphone|ipad|ipod|android|blackberry|iemobile/) ? true : false;
globalVariables.isIos = globalVariables.ua.match(/iphone|ipad|ipod/) ? true : false;
globalVariables.isAnd = globalVariables.ua.match(/android/) ? true : false;

function setSize() {
	let containerMarginTop = 0,
			mobileGnbMarginTop = 0,
			gnbMarginTop = 0,
			filters = document.querySelectorAll('#mobile-gnb');

	if (globalVariables.isMobile) {
		if (document.body.clientWidth >= 768) {
			gnbMarginTop = 50;
		} else {
			containerMarginTop = 100;
			mobileGnbMarginTop = 50;
			document.getElementById('mobile-gnb') && filters.length && (() => {
        containerMarginTop = $('#mobile-gnb').outerHeight() > 90 ? 148 : 100;
				for (let i = 0, len = filters.length; i < len; i++) {
					// filters[i].setAttribute('class', filters[i].getAttribute('class').replace(/\s*none\s*/g, ' '));
				}
				// containerMarginTop = 148;
			})();
		}
		if (document.getElementById('gnb')) {
			document.getElementById('gnb').style.marginTop = gnbMarginTop + 'px';
			document.getElementById('mobile-gnb').style.top = mobileGnbMarginTop + 'px';
			document.getElementById('body-container').style.marginTop = containerMarginTop + 'px';
			document.querySelector('.download-banner').style.display = 'block';
			document.querySelector('.download-banner p span').innerHTML = (globalVariables.isIos ? 'App Store' : 'Play Store');
		}
	} else {
		if (document.body.clientWidth >= 768) {
		} else {
			containerMarginTop = 50;
		}

		if (document.getElementById('gnb')) {
			document.getElementById('gnb').style.marginTop = gnbMarginTop + 'px';
			document.getElementById('mobile-gnb').style.top = mobileGnbMarginTop + 'px';
			document.getElementById('body-container').style.marginTop = containerMarginTop + 'px';
			document.querySelector('.download-banner').style.display = 'none';
		}

    $('body').animate({ scrollTop: 0 }, 0);
	}
}

function l(arg) {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    console.log(arg);
  }
}

export { auth, debounce, getPastTime, getQueryString, removeProps, setDownloadOptions, throttle, getCookie, setCookie, removeCookie, setSize, l };
export default globalVariables;

